import React, { useState } from 'react';
import { SUPPORT_EMAIL } from '../constants/companyInfo';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import { faqPageSchema } from '../constants/structuredData';
import './Page.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How can I use my healthcare services?',
      answer: 'You can use your services from member\'s area. There is a dedicated page of book services where you check all services that you can use.'
    },
    {
      question: 'How will I add my family members?',
      answer: 'Under members area there is a page with a name of Manage Members. Please use that page to add and manage members.'
    },
    {
      question: 'Where should I connect for any complaint?',
      answer: `For service-related concerns, email ${SUPPORT_EMAIL}. For membership benefits, use the Contact Us form on our website — our team will respond within 24 hours.`
    },
    {
      question: 'Does specialist doctors included in my unlimited doctor consultation?',
      answer: 'Your package includes GP and 16+ specialist for unlimited doctor consultations.'
    },
    {
      question: 'Where can I check my health records?',
      answer:
        'Under the member area, open Order History to view your past bookings and download available lab reports and related records.'
    },
    {
      question: 'What types of health services you are providing?',
      answer: `Please refer to the PDF shared in your welcome email, or write to ${SUPPORT_EMAIL}.`
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page">
      <SeoHead {...PAGE_SEO.faq} jsonLd={faqPageSchema(faqs)} />
      <section className="page-header">
        <div className="container">
          <h1>Frequently Asked Questions</h1>
          <p className="page-subtitle">Find answers to common questions about our healthcare services</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="faq-container" role="list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
                role="listitem"
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-answer-${index}`}
                  id={`faq-question-${index}`}
                >
                  <span className="faq-question-text">{faq.question}</span>
                  <span className="faq-icon" aria-hidden="true">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </button>
                <div
                  id={`faq-answer-${index}`}
                  className="faq-answer"
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                >
                  <div className="faq-answer-inner">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="faq-note">
            <p>
              <strong>Still have questions?</strong> Don't hesitate to{' '}
              <a href="/contact">contact us</a> directly. We're here to help!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
